module.exports = __webpack_public_path__ + "img/71.ad3f4d62.png";